module.exports = __webpack_public_path__ + "img/red-x.376e8f22.svg";